<template>
  <div class="px-4 py-1 border rounded" :class="statusClass">
    Статус ЛМСЗ: {{ statusName }}
  </div>
</template>

<script>
  export default {
    name: 'LMSPStatus',

    props: {
      status: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      statusName() {
        return this.status && this.status.name;
      },
      statusSlug() {
        return this.status && this.status.slug;
      },
      statusClass() {
        return {
          'bg-white border-trueBlue': this.statusSlug === 'edited',
          'bg-teaGreen border-mayGreen': this.statusSlug === 'confirmed',
          'bg-lightRed border-PersianRed': this.statusSlug === 'excluded',
          'bg-veryPaleYellow border-bananaYellow':
            this.statusSlug === 'on_approval',
        };
      },
    },
  };
</script>
